import script from "./QuizzesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizzesPage.vue?vue&type=script&setup=true&lang=ts"

import "./QuizzesPage.vue?vue&type=style&index=0&id=e8bc1e40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8bc1e40"]])

export default __exports__